import type { FeedbackKind, FeedbackStatus } from "../types";

/** Almikia Epic PL (TASK-062): page size of the direccion "Reportes del piloto" list. */
export const PILOT_REPORTS_PER_PAGE = 25;

/** Max length of a direccion note (parity with the FakeRest guard and the table CHECK). */
export const PILOT_NOTE_MAX = 2000;

/** The statuses direccion can set from the screen ("nuevo" is only ever the initial state). */
export type ReviewStatus = Exclude<FeedbackStatus, "nuevo">;

/** Builds the server-side filter for the list; an unset facet adds no key. */
export const buildPilotReportsFilter = (
  status: FeedbackStatus | null,
  kind: FeedbackKind | null,
): Record<string, string> => ({
  ...(status ? { status } : {}),
  ...(kind ? { kind } : {}),
});

/**
 * The update payload: ONLY `status` (and the note when it was edited), the
 * two columns the data provider lets direccion change.
 */
export const buildReviewPatch = (
  status: ReviewStatus | undefined,
  note: string | undefined,
): { status?: ReviewStatus; direccion_note?: string | null } => ({
  ...(status ? { status } : {}),
  ...(note !== undefined ? { direccion_note: note.trim() || null } : {}),
});
